import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import Swal from "sweetalert2";
import {
  addSubject,
  getSubjectById,
  updateSubject,
} from "../../../services/SubjectService";
import { Button } from "react-bootstrap";

const AddSubject = () => {
  const [loading, setLoading] = useState(false);
  const [subjectName, setSubjectName] = useState("");
  const hasFetched = useRef(false);
  const { id } = useParams();
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      const fetchSubject = async () => {
        try {
          setLoading(true);
          const response = await getSubjectById(id);
          const subject = response?.data;
          setSubjectName(subject?.data?.name);
        } catch (err) {
          console.error("Error fetching subject:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchSubject();
    }
  }, [id]);

  const validateForm = () => {
    const newErrors = {};

    if (!subjectName.trim()) {
      newErrors.subjectName = "Title is required";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    try {
      // --- VALIDATE FORMS ---
      const formValid = validateForm();
      if (!formValid) {
        return;
      }
      const subjectData = { name: subjectName };

      setLoading(true);

      if (id) {
        // --- UPDATE EXISTING SUBJECT ---
        await updateSubject(id, subjectData);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Subject details updated successfully",
        });
        navigate("/subject", {
          state: {
            page: location.state?.page || 1,
            searchTerm: location.state?.searchTerm || "",
          },
        });
      } else {
        // --- CREATE NEW SUBJECT ---
        const response = await addSubject(subjectData);
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Subject added successfully",
          });
          navigate("/subject", {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
            },
          });
        }
      }
    } catch (err) {
      console.error("Error in handleSave:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Operation failed",
      });
    } finally {
      // hide loader
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu={`${id ? "Edit Subject" : "Add Subject"}`}
        motherMenu="Subject"
        activeMenuLink={`${id ? `edit-subject/${id}` : "add-subject"}`}
        motherMenuLink={"subject"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-8 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form>
                    <div
                      onClick={() => {
                        navigate("/subject", {
                          state: {
                            page: location.state?.page || 1,
                            searchTerm: location.state?.searchTerm || "",
                          },
                        });
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>Subject List</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <input
                        type="text"
                        className="form-control w-full"
                        placeholder="Title"
                        value={subjectName}
                        onChange={(e) => setSubjectName(e.target.value)}
                      />
                      {errors.subjectName && (
                        <div className="text-danger mt-1">
                          {errors.subjectName}
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              <hr style={{ margin: "0px" }} className="mx-2" />
              <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                <Button
                  type="button"
                  variant="secondary"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    navigate("/subject", {
                      state: {
                        page: location.state?.page || 1,
                        searchTerm: location.state?.searchTerm || "",
                      },
                    })
                  }}
                >
                  Back
                </Button>

                {/* Save / Update Button */}
                <Button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleSave}
                >
                  {id ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubject;
